import { Observable } from 'rxjs';
import { Injectable } from '@angular/core';
import { ApiService } from './api';

export interface ProgramUta {
  brand_id: number;
  category_id: string;
  headline: string;
}

export interface Program {
  airline_id: number;
  both_ways: boolean;
  brand_ids: number[];
  from_date: string;
  from_location: string;
  id: string;
  title: string;
  to_date: string;
  to_location: string;
  utas: ProgramUta[];
}

@Injectable({ providedIn: 'root' })
export class ProgramsService {
  apiPath: string = '/api';
  constructor(protected apiService: ApiService) { }

  getProgramsByAirlines(ids: number[], languageCode?: string): Observable<Program[]> {
    const path = `${this.apiPath}/programs?airline_ids=${ids}`;
    return this.apiService.getWithLanguage<Program[]>(path, languageCode);
  }

  getProgramsById(ids: string[], languageCode?: string): Promise<Program[]> {
    const path = `${this.apiPath}/programs?ids=${ids}`;
    return this.apiService
      .getWithLanguage<Program[]>(path, languageCode)
      .toPromise()
      .then(result => result ?? []);
  }
}
